import fetchHandler from '../tracking/fetchHandler'
import { getUserSessionId } from './userAuthStore'
import { firebaseDomain } from '../domain'

var respMiddlewareSubscribersObject = {}
var respMiddlewareSubscribers = []
function subscribeToAuthFetchResponses(id, subscriber) {
  respMiddlewareSubscribersObject[id] = subscriber
  respMiddlewareSubscribers = Object.values(respMiddlewareSubscribersObject)
}

// `baseUrl` in options overrides the default `api` base, for the standalone
// functions that are not routes on `api` (teacherResources). It is stripped
// out here rather than passed on to fetch.
const authFetchHandler = async (url, options, acceptedErrorCodes) => {
  const userSessionId = getUserSessionId()
  const { baseUrl = firebaseDomain, ...fetchOptions } = options ?? {}
  const headersClone = fetchOptions?.headers ?? {}
  const headers = {...headersClone, Authorization: 'Bearer ' + userSessionId}

  const resp = await fetchHandler(`${baseUrl}/${url}`, {...fetchOptions, headers}, acceptedErrorCodes)
  respMiddlewareSubscribers.forEach(subscriber => subscriber(resp.clone()))
  return resp
}

export { subscribeToAuthFetchResponses }
export default authFetchHandler
